<template>
  <div>
    <header class="modal-header">
      <h5 class="modal-title">Image Preview</h5>
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="$emit('close')">
        <span aria-hidden="true">&times;</span>
      </button>
    </header>
    <div class="modal-body">
      <!-- <div class="w-50 mx-auto my-0">
        <b-img :src="image" thumbnail fluid-grow center />
      </div> -->
      <b-img
        :src="image"
        thumbnail
        fluid-grow
        center
        style="max-width: 350px" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ImageModal',
  props: {
    image: {
      type: String,
      default: ''
    }
  }
}
</script>
